import React, { useState } from 'react';
import './PolicyPopup.css';

const PolicyPopup = ({ title, content, onClose }) => {
  const [activeSection, setActiveSection] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  
  const sections = React.Children.toArray(content.props.children);
  const isLastSection = activeSection === sections.length - 1;
  
  const handleNext = () => {
    if (isLastSection) {
      onClose();
      return;
    }
    
    if (!isAnimating) {
      setIsAnimating(true);
      setActiveSection(prev => prev + 1);
      setTimeout(() => setIsAnimating(false), 300);
    }
  };

  const handlePrev = () => {
    if (activeSection > 0 && !isAnimating) {
      setIsAnimating(true);
      setActiveSection(prev => prev - 1);
      setTimeout(() => setIsAnimating(false), 300);
    }
  };

  const handleDotClick = (index) => {
    if (!isAnimating && index !== activeSection) {
      setIsAnimating(true);
      setActiveSection(index);
      setTimeout(() => setIsAnimating(false), 300);
    }
  };

  return (
    <div className="policy-popup-overlay" onClick={onClose}>
      <div className="policy-popup" onClick={e => e.stopPropagation()}>
        <div className="policy-header">
          <h2>{title}</h2>
          <button className="close-button" onClick={onClose} aria-label="Close">
            <span>×</span>
          </button>
        </div>
        
        <div className="policy-content">
          <div className="progress-bar">
            <div 
              className="progress-fill"
              style={{ width: `${(activeSection / (sections.length - 1)) * 100}%` }}
            />
          </div>

          <div className={`policy-section-content ${isAnimating ? 'animating' : ''}`}>
            {sections[activeSection]}
          </div>

          <div className="policy-navigation">
            {sections.map((_, index) => (
              <button
                key={index}
                className={`nav-dot ${index === activeSection ? 'active' : ''}`}
                onClick={() => handleDotClick(index)}
                aria-label={`Go to section ${index + 1}`}
              >
                <span className="dot-indicator" />
              </button>
            ))}
          </div>

          <div className="policy-controls">
            <button 
              className={`nav-button prev ${activeSection === 0 ? 'disabled' : ''}`}
              onClick={handlePrev}
              disabled={activeSection === 0 || isAnimating}
            >
              <span className="button-content">
                <span className="arrow">←</span>
                <span className="text">Previous</span>
              </span>
            </button>

            <span className="section-indicator">
              Section {activeSection + 1} of {sections.length}
            </span>

            <button 
              className={`nav-button next ${isLastSection ? 'done' : ''}`}
              onClick={handleNext}
              disabled={isAnimating}
            >
              <span className="button-content">
                <span className="text">{isLastSection ? 'Done' : 'Next'}</span>
                {!isLastSection && <span className="arrow">→</span>}
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PolicyPopup; 